import React from 'react';
import './LiquidGlassCard.css';

const LiquidGlassCard = ({ children, className = '', hover = false }) => {
  return (
    <div className={`liquid-glass-card ${hover ? 'liquid-glass-card-hover' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default LiquidGlassCard;
